import { Component } from '@angular/core';

@Component({
  templateUrl: './rl-localiza.component.html',
  styleUrl: './rl-localiza.component.scss',
})
export class RLLocalizaComponent {}
